<template>
  <div class="container">
    <table class="score-table">
      <tr>
        <th v-for="h in headers" :key="h.key" :style="h.width ? `width:${h.width}` : ''" class="table-header">
          {{ h.label }}
        </th>
      </tr>
      <tr v-for="p in numPlayers" :key="p">
        <td v-for="h in headers" :key="h.key">
          <div class="player-name-input-container" v-if="h.key === 'player'">
            <div v-if="$route.name !== 'result'">
              <input v-if="h.key === 'player'" type="text" :class="{
                'player-name-input': true,
                'player-on-direct':
                  ['ShowAnswer', 'Question', 'Answer'].includes(
                    questionDisplayMode
                  ) &&
                  getCurrent.player === getPlayers[p - 1].id &&
                  !finishGame,
              }" v-model="getPlayers[p - 1].name" :placeholder="getPlayers[p - 1].placeholder" maxlength="30" />
              <font-awesome-icon v-if="!getPlayers[p - 1].emptySeat" icon="fa-solid fa-square-minus"
                class="empty-seat-button" @click="toggleEmpty(getPlayers[p - 1].id)" />
              <font-awesome-icon v-if="getPlayers[p - 1].emptySeat" icon="fa-solid fa-square-plus"
                class="empty-seat-button" @click="toggleEmpty(getPlayers[p - 1].id)" />
            </div>
            <div v-else>
              <div
                :class="{ 'player-name-input': true, 'seat-empty': getPlayers[p - 1].emptySeat || !getPlayers[p - 1].name }">
                {{ getPlayers[p - 1].name || getPlayers[p - 1].placeholder }}
              </div>
            </div>
          </div>
          <div class="scores-ba scores" v-if="h.key === 'score'">
            {{ getScores.scores[p - 1] }}
          </div>
          <div class="scores-ba" v-if="h.key === 'owns'">
            {{ `${getScores.owns[p - 1][0]}/${getScores.owns[p - 1][1]}` }}
          </div>
          <div class="scores-ba" v-if="h.key === 'correct'">
            {{ getScores.totalCorrect[p - 1] }}
          </div>
          <div class="scores-ba" v-if="h.key === 'bonusAttempts'">
            {{ getScores.bonusAttempts[p - 1] }}
          </div>
          <div class="scores-ba" v-if="h.key === 'notAnswered'">
            {{ getScores.notAnswered[p - 1] }}
          </div>
          <div class="scores-ba" v-if="h.key === 'stake5'">
            {{ `${getScores.stake5[p - 1][0]}/${getScores.stake5[p - 1][1]}` }}
          </div>
          <div class="scores-ba" v-if="h.key === 'stake10'">
            {{
              `${getScores.stake10[p - 1][0]}/${getScores.stake10[p - 1][1]}`
            }}
          </div>
          <div class="scores-ba" v-if="h.key === 'stake20'">
            {{
              `${getScores.stake20[p - 1][0]}/${getScores.stake20[p - 1][1]}`
            }}
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
export default {
  name: "ScorerTable",
  computed: {
    ...mapGetters(["getPlayers", "getScores", "getCurrent"]),
    ...mapState(["numPlayers", "questionDisplayMode", "finishGame"]),
  },

  data() {
    return {
      headers: [
        {
          label: "Players",
          key: "player",
        },
        {
          label: "Score",
          width: "8%",
          key: "score",
        },
        {
          label: "Owns",
          width: "8%",
          key: "owns",
        },
        {
          label: "Correct",
          width: "8%",
          key: "correct",
        },
        {
          label: "BA",
          width: "8%",
          key: "bonusAttempts",
        },
        {
          label: "X",
          width: "8%",
          key: "notAnswered",
        },
        {
          label: "S5",
          width: "8%",
          key: "stake5",
        },
        {
          label: "S10",
          width: "8%",
          key: "stake10",
        },
        {
          label: "S20",
          width: "8%",
          key: "stake20",
        },
      ],
    };
  },

  methods: {
    ...mapActions(["toggleEmpty"]),
  },
};
</script>

<style scoped>
.container {
  display: flex;
  width: 99%;
}

.score-table {
  width: 100%;
}

.table-header {
  font-size: 2.75vmin;
  height: 40px;
  background-color: #d7d7d7;
}

.labels {
  flex: 1 1 auto;
}

.score-table {
  flex: 16 16 auto;
}

.player-name-th {
  width: 20%;
}

.scores-ba {
  background-color: #fdfcf6;
  border: none;
  text-align: center;
  font-family: Nunito;
  font-size: 2.5vmin;
  width: 100%;
}

.scores {
  font-size: 2.75vmin;
  font-weight: bold;
}

.player-name-input {
  background-color: #fdfcf6;
  border: 2px solid gray;
  border-radius: 2px;
  font-weight: bold;
  font-family: Nunito;
  width: 100%;
  padding: 5px;
  font-size: 2.5vmin;
  text-align: center;
  box-sizing: border-box;
}

.player-name-input::placeholder {
  font-weight: normal;
  color: #696969;
}

.player-on-direct {
  background-color: #f2dfb6;
  border: 3px solid #333333;
}

.player-name-input-container {
  position: relative;
}

.empty-seat-button {
  position: absolute;
  right: 0.5vmin;
  top: 0.5vmin;
  height: 2vmin;
  color: #5f5f5f;
  cursor: pointer;
}

.empty-seat-button:hover {
  color: rgb(135, 135, 135);
}

.seat-empty {
  opacity: 0.3;
}
</style>
